import AsyncGroupFactory from '@/Factories/AsyncGroupFactory';
import ComponentManager from '@/Management/ComponentManager';
import PropertyGroupBoxViewModelT from '@/ViewModels/Controls/PropertyGroupBoxViewModel';
import PropertyGroupBoxT from '@/Controls/PropertyGroupBox';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import {DisposeBehavior} from '#/DefaultViewExtensionInterfaces';

export default class PropertyGroupFactory extends AsyncGroupFactory {

    private PropertyGroupBoxViewModel = ComponentManager.getViewModel<typeof PropertyGroupBoxViewModelT>('PropertyGroupBoxViewModel');
    private PropertyGroupBox = ComponentManager.getControl<typeof PropertyGroupBoxT>('PropertyGroupBox');
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');

    /**
     * @override
     */
    viewModel: PropertyGroupBoxViewModelT;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override 
     */
    protected createViewModel(): PropertyGroupBoxViewModelT {
        return new this.PropertyGroupBoxViewModel({
            context: this.context,
            layout: this.layout,
            isSummaryViewMode: this.isSummaryViewMode,
            detailViewGroups: this.detailViewGroup.detailViewGroups,
            detailViewItems: this.detailViewGroup.items,
            parentLocator: this.locator,
            locator: (this.detailViewGroup as any)._type === 'detailViewDTO'
                ? (this.detailViewGroup as any).typeName : this.detailViewGroup.name // TODO: Typecheck
        });
    }

    /**
     * @override 
     */
    protected createControl(): PropertyGroupBoxT {
        return new this.PropertyGroupBox(this.viewModel);
    }

    protected getDisposeBehavior(): DisposeBehavior {
        return "Asynchronous";
    }
}

ComponentManager.setFactory('PropertyGroup', PropertyGroupFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');